import { useState } from "react";
import SubmitSkeleton from "../SubmitSkeleton";
import { useCaseContext } from "../../../context/CaseContext";
import CustomLabel from "../../common/CustomLabel";
import { DatePicker } from "rsuite";
import "rsuite/DatePicker/styles/index.css";

const IncidentDateStage = ({
  setStep,
}: {
  setStep: (step: number) => void;
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const { incidentDate, caseType, updateCaseData } = useCaseContext();

  const handleNext = () => {
    if (incidentDate) {
      setErrorMessage("");
      setStep(3);
    } else {
      setErrorMessage("Please select incident date before proceeding.");
    }
  };

  const handlePrev = () => {
    if (typeof caseType === "object" && caseType?.custom) {
      setStep(0);
    } else {
      setStep(1);
    }
  };

  const handleDateChange = (date: Date | null) => {
    if (date) {
      // Convert Date to ISO string format (YYYY-MM-DD) and store in context
      const formattedDate = date.toISOString().split("T")[0];
      updateCaseData("incidentDate", formattedDate);
    } else {
      updateCaseData("incidentDate", null);
    }

    setErrorMessage("");
  };

  return (
    <SubmitSkeleton
      progress={2 / 10}
      onPrev={handlePrev}
      onNext={handleNext}
      canProceed={!!incidentDate}
    >
      <div className="flex flex-col gap-4 items-start">
        {errorMessage && (
          <p className="text-red-500 text-sm mb-1">{errorMessage}</p>
        )}

        <CustomLabel
          labelText="Date of incident"
          labelWrapClass="!w-auto"
          isRequired
        >
          <div className="w-full">
            <DatePicker
              format="MM-dd-yyyy"
              placeholder="MM-DD-YYYY"
              value={incidentDate ? new Date(incidentDate) : null}
              onChange={handleDateChange}
              cleanable
              className="w-full"
              style={{
                borderRadius: "0.375rem",
                padding: "0.5rem 0.75rem",
                marginBottom: "2.5rem",
                fontSize: "20px",
              }}
              oneTap
              shouldDisableDate={(date) => date > new Date()}
              menuClassName="text-base"
            />
          </div>
        </CustomLabel>
      </div>
    </SubmitSkeleton>
  );
};

export default IncidentDateStage;
